import React, {useContext} from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import Content from '../Content/Content';
import WrapperOverlay from './WrapperOverlay';
import ThemeContext from '../../contexts/themeContext';
import ProgressContainer from '../../components/ProgressContainer';
import ProgressLoading from '../../components/ProgressLoading';
import i18next from 'i18next';
import moment from 'moment-timezone';
import 'moment/locale/vi';

export const WrapperContainer = ({
	 children,
	 className = null,
	 ...props
}) => {
	const currentLang = i18next.language || 'ko';

	moment.locale(currentLang);
	moment.tz.setDefault('Asia/Seoul');

	const { rightPanel } = useContext(ThemeContext);

	return (
		<div
			className={classNames(
				'wrapper',
				{ 'wrapper-right-panel-active': rightPanel },
				className,
			)}
			{...props}>
			{children}
		</div>
	);
};

WrapperContainer.propTypes = {
	children: PropTypes.node.isRequired,
	className: PropTypes.string,
};

const Wrapper = () => {
	return (
		<>
			<WrapperContainer>
				<ProgressContainer />
				<ProgressLoading />
				<Content />
			</WrapperContainer>

			<WrapperOverlay />
		</>
	);
};

export default Wrapper;